import GuessArea from "../../components/Nursery/GeneralAwareness/GuessArea";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

document.title = "Mamas Guidance - Nursery - General Awareness - Neighbourhood Area"; // Set page title

const topics: MenuItem[] = [
    { url: "/nursery/general-awareness/neighbourhood-area/guess-the-area", title: "Guess the Area", component: GuessArea},
];


export default topics;